// src/data/getProdustosProyectosServicios.js
import photo from "../../media/img/companyInfo/default.png";


const getProdustosProyectosServicios = () => {
    const productos = [
        {
            id: 1,
            title: "OKAPI",
            icono: photo,
            description: "Transformamos tus procesos tradicionales en digitales para hacer tu negocio más ágil, eficiente y competitivo."
        },
        {
            id: 2,
            title: "OLAWI",
            icono: photo,
            description: "Soluciones tecnológicas a medida para la innovación empresarial."
        },
        {
            id: 3,
            title: "OKAPI",
            icono: photo,
            description: "Transformamos tus procesos tradicionales en digitales para hacer tu negocio más ágil, eficiente y competitivo."
        },
        {
            id: 4,
            title: "OLAWI",
            icono: photo,
            description: "Soluciones tecnológicas a medida para la innovación empresarial."
        }

    ];

    const servicios = [
        {
            id: 1,
            icono: photo,
            title: "Asesoramiento en Inteligencia Artificial",
            description: "Te guiamos en la integración de soluciones de IA para optimizar decisiones, automatizar tareas y descubrir nuevas oportunidades."
        },
        {
            id: 2,
            icono: photo,
            title: "DIGITALIZACION",
            description: "Transformamos tus procesos tradicionales en digitales para hacer tu negocio más ágil, eficiente y competitivo."
        },
        {
            id: 3,
            icono: photo,
            title: "Asesoramiento en Automatizaciones",
            description: "Identificamos y desarrollamos automatizaciones que ahorran tiempo, reducen errores y mejoran la productividad de tu empresa."
        },
        {
            id: 4,
            icono: photo,
            title: "Asesoramiento en Business Intelligence",
            description: "Convertimos tus datos en información valiosa mediante análisis avanzados para ayudarte a tomar decisiones estratégicas con confianza."
        },
        {
            id: 5,
            icono: photo,
            title: "Estrategia y Negocio",
            description: "Te acompañamos en el diseño de estrategias sólidas para potenciar tu modelo de negocio, crecer de forma sostenible y destacar en tu sector."
        }
    ];

    const proyectos = [
        {
            id: 1,
            icono: photo,
            title: "Asesoramiento en Inteligencia Artificial",
            description: "Transformamos tus procesos tradicionales en digitales para hacer tu negocio más ágil, eficiente y competitivo."
        },
        {
            id: 2,
            icono: photo,
            title: "DIGITALIZACION",
            description: "Te guiamos en la integración de soluciones de IA para optimizar decisiones, automatizar tareas y descubrir nuevas oportunidades."
        },
        {
            id: 3,
            icono: photo,
            title: "Asesoramiento en Automatizaciones",
            description: "Identificamos y desarrollamos automatizaciones que ahorran tiempo, reducen errores y mejoran la productividad de tu empresa."
        },
        {
            id: 4,
            icono: photo,
            title: "Asesoramiento en Automatizaciones",
            description: "Identificamos y desarrollamos automatizaciones que ahorran tiempo, reducen errores y mejoran la productividad de tu empresa."
        }
    ];

    return { productos, servicios, proyectos };
};

export default getProdustosProyectosServicios;